module.exports = __webpack_public_path__ + "img/house4.png";